import { createApp } from 'vue';
import LottieToWebmConverter from '@/Components/LottieToWebmConverter.vue';
import '@styles/app.css';

createApp(LottieToWebmConverter).mount('#lottie-to-webm-converter');
